module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tit"
  }, [_vm._v("Tempestuous")]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("KIM ASKEW and AMY HELMES")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Merit Press",
      "height": "46",
      "src": "OEBPS/images/Merit_Press.gif",
      "width": "150"
    }
  }), _c('br'), _vm._v("\n  F+W Media, Inc.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b4e4659","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tit.vue
// module id = 60
// module chunks = 0